module.exports = __webpack_public_path__ + "img/shops_back.c08a61e2.jpg";